import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 197 167", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "m95.562 116.425 15.399-15.399 24.185 24.186V15.398h21.776v109.814l24.185-24.186 15.398 15.399-50.471 50.47zm-55.978 35.073V41.684L15.399 65.869 0 50.47 50.472 0l50.47 50.47-15.398 15.4-24.185-24.186v109.814z",
    fill: "currentColor"
  }
) });
export {
  l as S
};
